<semeris-hint-overlay
  [contentContainerClass]="['semeris-overlay-container', 'comments-label-overlay', 'mat-elevation-z4']"
  [overlayPanelClass]="['semeris-overlay']"
>
  <ng-template #hintText>
    <button fastTooltip="Labels Auto-added to New Notes" cdkOverlayOrigin semerisIconButton  color="accent">
      <mat-icon [matBadge]="(defaultLabels$ | async)?.length" matBadgeColor="warn" color="accent" aria-hidden="false">label</mat-icon>
    </button>
  </ng-template>
  <ng-template #hintContent>
    <div class="selected-labels-title">
      <h3>Labels Auto-added to New Notes</h3>
    </div>
    <span class="semeris-overlay-placeholder"
      >We'll auto-add these labels to your new notes. This saves time and simplifies finding and exporting them later.
    </span>
    <semeris-label-input
      [labels]="labels$ | async"
      [value]="defaultLabels$ | async"
      (valueChanged)="onValueChanged($event)"
      (labelCreated)="onLabelCreated($event)"
    ></semeris-label-input>
  </ng-template>
</semeris-hint-overlay>

